window.addEventListener('DOMContentLoaded', () => {
  const sliders = document.querySelectorAll('.dragscrolling');
  let isDown = false;
  let startX;
  let scrollLeft;

  if (!sliders.length) return;

  sliders.forEach(slider => { 
    slider.addEventListener('mousedown', (e) => {
      isDown = true;
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
    });

    slider.addEventListener('mouseleave', () => {
      isDown = false;
    });

    slider.addEventListener('mouseup', () => {
      isDown = false;
    });

    slider.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - slider.offsetLeft;
      const walk = (x - startX) * 3; 
      slider.scrollLeft = scrollLeft - walk;
    });
  });
});